import React from 'react';
import PropTypes from 'prop-types';
import { getInitials } from 'utils';
import { Avatar } from 'sharedComponents';
import { Drawer, Divider, ListItem, List, Badge, ListItemText, Button, Grid } from '@material-ui/core';
import { MORE_MENU_ITEMS } from 'constants';
import MoreMenuItem from './MoreMenuItem';

const MoreMenu = ({
  classes,
  config,
  user,
  open,
  onClose,
  history,
  closeStylyzeApp,
  openStylyzeLandingPage,
  isStylyzeAppOpen,
}) => {
  const onClick = async (path, isLooksApp) => {
    await closeStylyzeApp();

    if (isLooksApp && isStylyzeAppOpen()) {
      openStylyzeLandingPage({
        stylyzeAccId: config.get('stylize.accId'),
        associatePin: user.employeeNumber,
        associateEmail: user.email,
      });
    } else {
      history.push(path);
    }

    onClose();
  };

  return (
    <Drawer open={open} onClose={onClose} variant="persistent" classes={{ paper: classes.paper }}>
      <List>
        <ListItem
          disableGutters
          className={classes.user}
          onClick={() => onClick('/account')}
          button
          data-testid="more-menu-user-link"
        >
          <Badge
            classes={{ badge: classes.badge }}
            overlap="circle"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            variant="dot"
          >
            <Avatar className={classes.avatarUserInitials}>{getInitials(`${user.firstName} ${user.lastName}`)}</Avatar>
          </Badge>
          <ListItemText primary={`${user.firstName} ${user.lastName}`} classes={{ primary: classes.userText }} />
        </ListItem>
        <Divider />
        {MORE_MENU_ITEMS.map(({ title, path, toggle, icon, isLooksApp }, i) => (
          <MoreMenuItem
            key={title}
            onClick={() => onClick(path, isLooksApp)}
            title={title}
            toggle={toggle}
            icon={icon}
            data-testid={`more-menu-${i}-link`}
          />
        ))}
      </List>
      <div className={classes.grow} />
      <Grid>
        <Button
          startIcon={<div className={classes.helpIcon} />}
          className={classes.help}
          onClick={() => onClick('/help')}
          data-testid="more-menu-help-link"
        >
          Help & Feedback
        </Button>
      </Grid>
    </Drawer>
  );
};

MoreMenu.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

MoreMenu.defaultProps = {
  classes: {},
  user: {
    firstName: '',
    lastName: '',
  },
  open: false,
  onClose: () => {},
  history: {
    push: () => {},
  },
};

export default MoreMenu;
